import classes from '../index.module.scss';
import React, { useContext } from 'react';
import { SearchContext } from '../../../context/Search';
import { HashLink } from 'react-router-hash-link';
import { UserContext } from '../../../context/User';

const FederalContactsTableBody = () => {
  const { searchedData } = useContext(SearchContext);
  const { isLoggedIn } = useContext(UserContext);

  return (
    <>
      {
        searchedData.map(item => {
          const { posted_date, title, sol_no, agency, id } = item;

          return (
            <tr key={id}>
              <td className={`${classes.No_Wrap} ${classes.Title_Normal}`}>{posted_date}</td>
              <td>
                <p className={classes.Title_Bold}>
                  <HashLink
                    to={isLoggedIn ? `/opportunity?id=${sol_no}` : '/#basic-info'}
                    smooth
                  >
                    {title}
                  </HashLink>
                </p>
                <p className={classes.Title_Light}>Solicitation number: {sol_no}</p>
              </td>
              <td  className={`${classes.No_Wrap} ${classes.Title_Normal}`}>Federal Contract</td>
              <td className={classes.Title_Normal}>{agency.department ? agency.department : "-"}</td>
            </tr>
          )
        })
      }
    </>
  )
}

export default FederalContactsTableBody;